const singleProductDesktop = () => {
  const body: HTMLElement = document.querySelector('body');
  const descriptionContent: HTMLElement = document.querySelector('.desktopcontent__description');
  const productinfoContent: HTMLElement = document.querySelector('.desktopcontent__productinfo');
  const shipmentContent: HTMLElement = document.querySelector('.desktopcontent__shipment');

  const contentArray = [descriptionContent, productinfoContent, shipmentContent];
  const headerTitles: NodeListOf<HTMLElement> = document.querySelectorAll('.desktopcontent__header-title');

  // Remove active/not-indisplay class from not clicked header titles/content divs
  const removeActives = () => {
    headerTitles.forEach((headerTitle: HTMLElement) => {
      headerTitle.classList.remove('active');
    });
    contentArray.forEach((content: HTMLElement) => {
      content.classList.add('not-ondisplay');
    });
  };

  // Filler function for the loader-bar animations
  const loaderElementsDesktop: NodeListOf<HTMLElement> = document.querySelectorAll('.loader-bar--desktop');

  const growFillersDesktop = () => {
    loaderElementsDesktop.forEach((loader) => {
      const fillerElement = loader.lastElementChild as HTMLElement;
      const dataLoader = loader.dataset.loader;
      setTimeout(() => {
        fillerElement.classList.add(dataLoader);
      }, 250);
    });
  };

  // Observer that calls the filler function when the div is in view
  const fillerElementDesktop: HTMLElement = document.querySelector('.desktopcontent__description-bars');

  const isInView = (element: HTMLElement) => {
    const bounding = element.getBoundingClientRect();

    if (bounding.top >= 0) {
      return true;
    }
    return false;
  };

  window.addEventListener('scroll', () => {
    if (isInView(fillerElementDesktop) && body.offsetWidth > 768) {
      growFillersDesktop();
    }
  }, false);

  // Set active/in-display for click header title
  const headerTitlesText = [];

  headerTitles.forEach((headerTitle) => {
    const headerText = headerTitle.textContent;
    headerTitlesText.push(headerText);

    headerTitle.addEventListener('click', () => {
      if (headerTitlesText.indexOf(headerText) === 0 && !headerTitle.classList.contains('active')) {
        removeActives();
        headerTitle.classList.add('active');
        descriptionContent.classList.toggle('not-ondisplay');
      } else if (headerTitlesText.indexOf(headerText) === 1 && !headerTitle.classList.contains('active')) {
        removeActives();
        headerTitle.classList.add('active');
        productinfoContent.classList.toggle('not-ondisplay');
      } else if (headerTitlesText.indexOf(headerText) === 2 && !headerTitle.classList.contains('active')) {
        removeActives();
        headerTitle.classList.add('active');
        shipmentContent.classList.toggle('not-ondisplay');
      }
    });
  });
};

export default singleProductDesktop;
